import { DashboardLayout } from 'layouts';
import React from 'react';
import './Payment.scss';

const Payment = () => {
  return <DashboardLayout title="Payment">Payment</DashboardLayout>;
};

export default Payment;
